import React from "react";

export default ({ color = "black", opacity = "0.8", borderColor = "fff", className = "", onClick = () => {} }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    className={className ? className : ""}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="addpic">
      <circle id="Ellipse 4" cx="15" cy="15" r="13" fill="#FDFDFD" />
      <path
        id="Posting_picture_upload_icon"
        d="M9.18015 17.0759C8.91484 17.4027 9.1474 17.8911 9.56833 17.8911H20.4288C20.8539 17.8911 21.0851 17.3942 20.8113 17.069L18.6272 14.4749C18.4317 14.2426 18.0759 14.2368 17.8729 14.4626L16.323 16.1865C16.1199 16.4125 15.7638 16.4065 15.5683 16.1739L13.0816 13.2136C12.8795 12.9731 12.5085 12.9762 12.3105 13.22L9.18015 17.0759Z"
        fill={color}
        fillOpacity={opacity}
      />
    </g>
  </svg>
);
